import { useTranslation } from "react-i18next";
import { CalendarDays } from "lucide-react";
import { NeuSelect } from "../../../components/neu/Neu";
import { CAL_SYSTEMS, resolveSystem, localeFor } from "../../../lib/calendar";

// اختيار نظام التقويم للفرع (داخل الأساسيات) مع معاينة حيّة لتاريخ اليوم بالنظام المختار.
export const CalendarSystemField = ({ form, set }) => {
  const { t, i18n } = useTranslation();
  const value = form.calendar_system || "auto";
  const resolved = resolveSystem(value, form.timezone_name);
  const sample = new Date().toLocaleDateString(localeFor(resolved, i18n.language), {
    day: "numeric", month: "long", year: "numeric",
  });

  return (
    <div className="sm:col-span-2">
      <p className="label-xs mb-2 flex items-center gap-1.5 text-violet-500">
        <CalendarDays className="h-3.5 w-3.5" /> {t("branches.calendarSystem")}
      </p>
      <NeuSelect data-testid="branch-calendar_system" value={value}
        onChange={(e) => set("calendar_system", e.target.value)}>
        {CAL_SYSTEMS.map((o) => (
          <option key={o} value={o}>{t(`branches.calendarOpt.${o}`)}</option>
        ))}
      </NeuSelect>
      <p className="mt-1 text-xs text-muted-foreground" data-testid="branch-calendar_system-hint">
        {t("branches.calendarHint")}{" "}
        <span className="font-mono font-bold text-foreground" data-testid="branch-calendar-sample">{sample}</span>
      </p>
    </div>
  );
};
